import {ArrayElement} from 'shared/web';

import {DefinitionResponseBody, EntityColumnResponseBody} from '../types/Api';

export const isEntityColumnResponseBody = (
  data: ArrayElement<DefinitionResponseBody['columns']>
): data is EntityColumnResponseBody => 'resourceId' in data;
